module.exports = __webpack_public_path__ + "static/media/SaveScoreIcon.0a44e276.svg";